<template>
  <div class="content">
    <h3 ref="pageHeader" class="pageHeader">仪器设备院系汇总</h3>
    <div style="display: flex;">
      <div
        style="width:250px;box-sizing: border-box;box-shadow: rgb(229 229 229) 0px 0px 1px 1px;min-height: 500px;border-radius: 8px;">
        <div class="win-title"><i class="el-icon-caret-bottom" style="font-size: 18px;padding-right: 4px;"></i>全校汇总数据
        </div>
        <div style="padding: 8px;">
          <div :class="['stru-item', currentNode == '' ? 'is-active' : '']" @click="handleNodeClick('')">全校</div>
          <template v-if="countData.structureList">
            <div v-for="item in countData.structureList" :key="item.structure_ids"
              :class="['stru-item', currentNode == item.name ? 'is-active' : '']"
              @click="handleNodeClick(item.name)">
              {{ item.name }}
            </div>
          </template>
          <div class="stru-item" v-else>--暂无院系--</div>
        </div>
        <!-- <el-tree :data="treeArr" :props="defaultProps" @node-click="handleNodeClick" style="padding: 8px;"></el-tree> -->
      </div>
      <div style="flex:1;overflow: auto;margin-left: 8px;">
        <div class="flex-div">
          <div class="f-item">
            <p class="p-title">仪器设备数量 </p>
            <div class="ul-div" id="pieEqnumOption">
              <v-chart theme="macarons" :options="pieEqnumOption" style="margin:0 atuo;" />
            </div>
          </div>
          <div class="f-item">
            <p class="p-title">仪器设备总金额</p>
            <div class="ul-div" id="pieEqTotalOption">
              <v-chart theme="macarons" :options="pieEqTotalOption" style="margin:0 atuo;" />
            </div>
          </div>
          <div class="f-item" style="width: 100%;">
            <p class="p-title">仪器设备实有数</p>
            <div class="ul-div" id="barEqOption" style="height: 320px;">
              <v-chart theme="macarons" :options="barEqOption" style="margin:0 atuo;" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts';

export default {
  name: 'trainingRoom',
  data() {
    return {
      classRooms: [],
      pieEqnumOption: {},
      pieEqTotalOption: {},
      barEqOption: {},
      defaultProps: {
        children: 'sub',
        label: 'name',
      },
      selectName: '',
      organLabel: '',
      type: 'add',
      title: '新增',
      tableName: '实训日志',
      treeArr: [],
      tableArr: [],
      allArr: [],
      currentNode: '',
      countData: {}
    };
  },
  components: {
    'v-chart': ECharts,
  },
  created() { },
  mounted() {
    this.getList();
    // this.$store.dispatch('getTarinMent');
    this.treeArr = this.$store.state.organs[0] ? this.$store.state.organs[0].sub : [];
    this.pieEqnumOption = this.pieOption('仪器设备数量');
    this.pieEqTotalOption = this.pieOption('仪器设备总金额');
    this.barEqOption = this.barOption();
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    barOption() {
      return this.$until.deepCopy({
        dataset: {
          source: []
        },
        legend: {
          left: 'center',
          bottom: '2'
        },
        xAxis: { type: 'category',
        axisLabel:{
          // interval:0
        } },
        yAxis: {},
        series: [{
          type: 'bar',
          barMaxWidth: 24,
          barMinHeight:10,
          itemStyle: {
            borderRadius: 8,
            borderColor: '#fff',
            borderWidth: 2
          }
        }, {
          type: 'bar',
          barMaxWidth: 24,
          barMinHeight:10,
          itemStyle: {
            borderRadius: 8,
            borderColor: '#fff',
            borderWidth: 2
          }
        }]
      })
    },
    pieOption(title) {
      return this.$until.deepCopy({
        tooltip: {
          trigger: 'item'
        },
        legend: {
          // top: '5%',
          left: 'center',
          bottom: '2'
        },
        series:
        {
          name: title,
          type: 'pie',
          bottom: '20',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          minAngle: 16,
          label: {
            formatter: '{d}%',
            // position: 'center',
            position: 'outside',
            textStyle: {
              fontSize: '12',
              fontWeight: 'bold'
            }
          },
          itemStyle: {
            borderRadius: 8,
            borderColor: '#fff',
            borderWidth: 2
          },
          data: []
        }

      })
    },
    handleNodeClick(nodeData) {
      this.currentNode = nodeData;
      this.getList()
    },
    handleNode() {
      console.log(this.currentNode);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    getOrganList() {
      this.tableData1 = [];
      console.log(this.ruleForm);
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.major = strArr[1];
        this.ruleForm.class = strArr[2];
      }
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.major = '';
        this.ruleForm.class = '';
      }

      // this.ruleForm.type_value = this.selectNode.structure_ids;
      // this.organs = [this.selectNode];
    },
    handleQuery() {
      // this.beforeQuery();
      // this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype({ structure_1: this.currentNode });
      let res = await this.$api.instance.interfaceServer('api/new_device/statistics', 'get', params);
      if (res.code == 0 && res.data) {
        this.countData = res.data
        this.pieEqnumOption.series.data = [{ value: this.countData.device10LowQty, name: '十万元以下设备' },
        { value: this.countData.device10highQty, name: '十万元以上设备' }]
        this.pieEqTotalOption.series.data = [{ value: this.countData.device10LowTotal, name: '十万元以下设备' },
        { value: this.countData.device10highTotal, name: '十万元以上设备' }]

        // ['product', '2015', '2016'],
        //   ['Matcha Latte', 43.3, 85.8, 93.7],
        //   ['Milk Tea', 83.1, 73.4, 55.1]
        if (this.countData.list && this.countData.list.length > 0) {
          // this.countData.list = this.countData.list.concat(this.countData.list).concat(this.countData.list)
          
          let dataSet = this.countData.list.map(item => {
            return [item.device_name, item.last_academic_year_qty , item.this_academic_year_qty]
          })
          dataSet.unshift(['product', '上学年末仪器设备实有数', '本学年末仪器设备实有数'])
          this.barEqOption.dataset.source = dataSet
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.stru-item {
  font-size: 14px;
  padding: 4px 12px;
  margin: 4px 0;
  color: #666c71;
  cursor: pointer;
  border-radius: 2px;
  // &:hover {
  //   background-color: rgb(240 241 242);
  // }

}

.is-active {
  background-color: #e6e6e6;
}

.win-title {
  font-size: 15px;
  font-weight: bold;
  padding: 8px;
  background-color: rgb(240 241 242);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  color: var(--blue);
}

.echarts {
  margin: 0 auto;
  width: inherit;
  height: inherit;
}

.flex-div {
  width: 100%;
  // padding: 8px 0;
  // min-height: 500px;
  display: flex;
  flex-wrap: wrap;

  .f-item {
    // margin: 4px;
    width: calc(50% - 8px);
    // height: 400px;
    cursor: pointer;
    padding: 16px 12px;
    box-sizing: border-box;

    // margin-right: 8px;
    .div-style {
      display: flex;
      padding: 16px;
      border-radius: 4px;
      background: #ffffff;
      // margin-top: 16px;
      height: calc(100% - 72px);
      overflow: auto;

      div {
        width: 451px;
        height: 270px;
        overflow: hidden;

        // background:#ccc;
      }
    }

    .ul-div {
      padding: 16px;
      width: calc(100% - 32px);
      // height: calc(100% - 72px);
      height: 280px;
      background: #ffffff;
      border-radius: 4px;
      overflow: hidden;

      .ul-style {
        list-style: none;

        li {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          margin-bottom: 12px;

          .p-l {
            width: 320px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
          }

          .p-l:hover {
            color: #6d4827;
            text-decoration: underline;
          }

          .p-r {
            color: #8c8c8c;
            text-align: right;
          }
        }
      }
    }

    .p-title {
      font-size: 14px;
      color: #555;
      font-weight: bold;
      letter-spacing: 2px;
      text-align: center;

      // font-weight: bold;
      i {
        font-size: 18px;
        vertical-align: bottom;
        margin-right: 4px;
      }

      // font-style: italic;
      // font-weight: bold;
    }
  }
}
</style>
